export { VpPluginTypeIcon } from './VpPluginTypeIcon';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpPluginTypeIcon/index.js